import { Typography } from './Typography';
import styles from './Wordmark.module.css';
export function Wordmark({
  inverse = false,
  linked = true,
}: {
  inverse?: boolean;
  linked?: boolean;
}) {
  const content = (
    <Typography as="span" variant="brand" tone="inherit">
      Audit Vector
    </Typography>
  );
  return linked ? (
    <a
      className={`${styles.mark} ${inverse ? styles.inverse : ''}`}
      href="/"
      aria-label="Audit Vector — главная"
    >
      {content}
    </a>
  ) : (
    <div className={`${styles.mark} ${inverse ? styles.inverse : ''}`}>{content}</div>
  );
}
